import React, {useEffect, useState} from "react";
import EnterpriseComponent from "../../eoec/ec/EnterpriseComponent";
import {prepareBuffer} from "../../util/Buffer";
import {Avatar, Typography} from "@mui/material";
import {Black, Blue3, Grey3, Grey5, Grey6} from "../../theme/styles";
import {makeEnterpriseComponent} from "../../util/utility";


export default function PermissionConfiguration(props: any) {
    const [adminPrivilegeEnterpriseComponent] = useState(makeEnterpriseComponent("AdminPrivilege"));
    const [adminPrivilegeBuffer, setAdminPrivilegeBuffer] = React.useState<Map<string, any>>(new Map<string, any>());

    function enterpriseComponentLoadCompletedListener(ec: EnterpriseComponent) {
        let b:Map<string, any>[] = prepareBuffer(ec)
        setAdminPrivilegeBuffer(b[0]);
    }

    function enterpriseComponentValueChanged(ec: EnterpriseComponent) {
        let b:Map<string, any>[] = prepareBuffer(ec);
        setAdminPrivilegeBuffer(b[0]);
    }

    function enterpriseComponentUpdateRollbackCompleted(ec: EnterpriseComponent) {
        let b:Map<string, any>[] = prepareBuffer(ec);
        b = b.slice(ec.getRecordPointer(), ec.getRecordPointer() + 1);
        setAdminPrivilegeBuffer(b[0]);
    }

    useEffect(() => {
        adminPrivilegeEnterpriseComponent.newQuery();
        adminPrivilegeEnterpriseComponent.setAttributeValue("Name", props.name);
        adminPrivilegeEnterpriseComponent.setSearchSpecification({"Name": props.name})
        adminPrivilegeEnterpriseComponent.executeQuery(1, 1000);

        adminPrivilegeEnterpriseComponent.addLoadCompletedListener(enterpriseComponentLoadCompletedListener);
        adminPrivilegeEnterpriseComponent.addValueChangedListener(enterpriseComponentValueChanged);
        adminPrivilegeEnterpriseComponent.addUpdateRollbackCompletedListener(enterpriseComponentUpdateRollbackCompleted);

        return () => {
            adminPrivilegeEnterpriseComponent.removeLoadCompletedListener(enterpriseComponentLoadCompletedListener);
            adminPrivilegeEnterpriseComponent.removeValueChangedListener(enterpriseComponentValueChanged);
            adminPrivilegeEnterpriseComponent.removeUpdateRollbackCompletedListener(enterpriseComponentUpdateRollbackCompleted);
        }

    }, [adminPrivilegeEnterpriseComponent, props.adminPrivilegeUSID]);

    function stringAvatar(name: string) {
        return name
            .split(" ")
            .map(word => word[0])
            .join("")
            .substring(0, 2);
    }

    function renderPrivilege() {
        if (adminPrivilegeBuffer.get("ListOfGroup") === undefined) {
            return null;
        }
        return (
            <>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", backgroundColor: "#FFFFFF", marginTop: "30px", borderBottom: "1px solid #D8DDE4"}}>
                    <Typography style={{fontSize: 20, fontWeight: 500, color: "#000000"}}>{adminPrivilegeBuffer.get("Name")}</Typography>
                </div>
                <div style={{display: "flex", flexDirection: "column", backgroundColor: Grey3, border: "1px solid #7B8291", borderBottom: "0px", borderTopLeftRadius: "10px", borderTopRightRadius: "10px", borderBottomLeftRadius: "5px", borderBottomRightRadius: "5px", marginTop: "20px"}}>
                    <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", backgroundColor: "transparent", borderBottom: "1px solid #7B8291"}}>
                        <div style={{width: "410px"}}><Typography style={{fontSize: 14, fontWeight: 500, color: Black, margin: "10px"}}>Groups</Typography></div>
                        <div style={{width: "5px"}}><Typography style={{fontSize: 26, fontWeight: 500, color: Grey6, marginTop: "0px"}}>|</Typography></div>
                        <div style={{width: "300px"}}><Typography style={{fontSize: 14, fontWeight: 500, color: Black, margin: "10px"}}>Group Membership</Typography></div>
                    </div>
                    {adminPrivilegeBuffer.get("ListOfGroup")["Group"].map((group: any, index: number) => (
                        <div key={index} style={{display: "flex", flexDirection: "row", justifyContent: "space-between", backgroundColor: "#FFFFFF", borderBottom: "1px solid #EDEFF3"}}>
                            <div style={{display: "flex", flexDirection: "row"}}>
                                <div style={{marginTop: "10px", marginBottom: "10px", width: "410px"}}>
                                    <Typography style={{fontSize: 14, fontWeight: 500, color: Black, margin: "10px", textOverflow: "ellipsis", overflow: "hidden"}}>{group["Name"]}</Typography>
                                </div>
                                <div style={{width: "300px", display: "flex", flexDirection: "column", marginTop: "5px"}}>
                                    {group["ListOfEmployee"]["Employee"].length === 0 ? (
                                         <div style={{display: "flex", flexDirection: "row"}}>
                                            <div style={{width: "300px"}}><Typography style={{fontSize: 14, fontWeight: 500, color: Grey5, margin: "15px 0 8px 10px"}}>No assigned users</Typography></div>
                                        </div>
                                    ): null}
                                    {group["ListOfEmployee"]["Employee"].map((employee: any) => (
                                        <div key={employee.USID} style={{display: "flex", flexDirection: "row"}}>
                                            <div style={{fontSize: 14, fontWeight: 500, color: Black, margin: "3px 0 0 10px"}}>
                                                <Avatar sx={{bgcolor: Blue3, width: 25, height: 25, fontSize: "12px"}}>{stringAvatar(employee.UserName)}</Avatar>
                                            </div>
                                            <div style={{width: "300px"}}><Typography style={{fontSize: 14, fontWeight: 500, color: Black, margin: "5px 0 8px 10px"}}>{employee.UserName}</Typography></div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    ))}
                    <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", backgroundColor: "transparent", height: "5px"}}/>
                </div>
            </>
        )
    }
    return (
        <>
            {renderPrivilege()}
        </>
    )
}
